import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Link } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
const URLFontList = (props) => {
  const [characters, updateCharacters] = useState([]);
  const fileName = useFormInput("");
  const fileURL = useFormInput("");
  const [hold] = useState(props.dir);
  /* eslint-disable no-unused-vars */
  /* eslint-disable no-unused-vars */
  /* const newContainer = (event)=>{
      event.preventDefault();
      const newer ={
        "value":"unnamedItem",
        "label":"unamedItem",
        "order":characters.length+1,
        "id":characters.length+1
      }
      updateCharacters([...characters, newer]);
      
    } */
  const checkValueExist = (value) => {
    return characters.some(function (el) {
      return el.value === value;
    });
  };
  const newContainer = (event) => {
    event.preventDefault();
    const newer = {
      value: fileURL.value,
      label: fileName.value,
      order: characters.length + 1,
      file: fileURL.value,
      id: fileURL.value,
      fontType: "Custom URL Font",
    };

    if (characters.length < 2 && !checkValueExist(newer.value)) {
      updateCharacters([...characters, newer]);
      const newArray = [...characters, newer];
      props.onChange(newArray);
    } else {
      toastr.error("Limit Reached or item Already Exist", "Error");
    }
  };
  useEffect(() => {
    const getDetails = () => {
      const opt = props.listData.map((item) => ({
        value: item.itemid,
        label: item.itemRef,
        order: item.itemOrder,
        id: item.itemid,
        file: item.itemFile,
        fontType: item.itemFontType,
      }));

      updateCharacters(opt);
    };
    getDetails();
    // eslint-disable-line react-hooks/exhaustive-deps
    //eslint-disable-next-line
  }, [props.data, props.listData]);
  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    updateCharacters(newItems);
    const newArr = newItems;
    props.onChange(newArr);
  };
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    reorderArray(items);
  };
  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };
  return (
    <div className="row mb-2 mt-2">
      {!(hold === "rtl") && (
        <>
          <div className="col-sm-12">
            <div className="form-group">
              <div className="row">
                <div className="col-md-5">
                  <label>Font File URL</label>
                  <input
                    type="text"
                    name="fontUrl"
                    className="form-control inside-form"
                    placeholder="FontURL ..."
                    {...fileURL}
                    autoComplete="off"
                    disabled={props.name === "Custom URL Font" ? false : true}
                  />
                </div>
                <div className="col-md-5">
                  <label>Font Name</label>
                  <input
                    type="text"
                    name="fontName"
                    className="form-control inside-form"
                    placeholder="FontName ..."
                    {...fileName}
                    autoComplete="off"
                    disabled={props.name === "Custom URL Font" ? false : true}
                  />
                </div>

                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn btn-light btn-block"
                    style={{ width: "100px", marginTop: "8px", height: "40px" }}
                    onClick={newContainer}
                    disabled={
                      props.name === "Custom URL Font"
                        ? !fileURL.value
                          ? true
                          : !fileName.value
                            ? true
                            : false
                        : true
                    }
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId={"characters"}>
                {(provided) => (
                  <ul
                    className="products-list product-list-in-card pl-2 pr-2"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{ maxHeight: "350px", overflowY: "scroll" }}
                  >
                    {characters.map((item, index) => (
                      <Draggable
                        key={item.id + item.order}
                        draggableId={"item" + item.id}
                        index={index}
                      >
                        {(provided) => (
                          <li
                            className="item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div className="product-info">
                              <Link
                                to={"/item/" + item.value + "/" + item.id}
                                className="product-title"
                              >
                                {item.label}
                                <span className="badge badge-warning float-left">
                                  {item.order}
                                </span>
                              </Link>
                              <div
                                className="text-right"
                                style={{ display: "inline", float: "right" }}
                              >
                                <Link
                                  className="btn btn-light btn-sm"
                                  to="#!"
                                  onClick={(event) =>
                                    handleRemove(event, index)
                                  }
                                >
                                  <i className="fas fa-trash"></i>
                                </Link>
                              </div>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </>
      )}

      {hold === "rtl" && (
        <>
          <div className="col-sm-12">
            <div className="form-group">
              <div className="row">
                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn btn-light btn-block"
                    style={{ width: "100px", marginTop: "8px", height: "40px" }}
                    onClick={newContainer}
                    disabled={
                      props.name === "Custom URL Font"
                        ? !fileURL.value
                          ? true
                          : !fileName.value
                            ? true
                            : false
                        : true
                    }
                  >
                    Add
                  </button>
                </div>
                <div className="col-md-5">
                  <label
                    className={
                      props.dir === "rtl" ? "float-right" : "float-left"
                    }
                  >
                    Font File URL
                  </label>
                  <input
                    type="text"
                    name="fontUrl"
                    className="form-control inside-form float-right"
                    dir={props.dir}
                    placeholder="FontURL ..."
                    {...fileURL}
                    autoComplete="off"
                    disabled={props.name === "Custom URL Font" ? false : true}
                  />
                </div>
                <div className="col-md-5">
                  <label
                    className={
                      props.dir === "rtl" ? "float-right" : "float-left"
                    }
                  >
                    Font Name
                  </label>
                  <input
                    type="text"
                    name="fontName"
                    className="form-control inside-form float-right"
                    dir={props.dir}
                    placeholder="FontName ..."
                    {...fileName}
                    autoComplete="off"
                    disabled={props.name === "Custom URL Font" ? false : true}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId={"characters"}>
                {(provided) => (
                  <ul
                    className="products-list product-list-in-card pl-2 pr-2"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{ maxHeight: "350px", overflowY: "scroll" }}
                  >
                    {characters.map((item, index) => (
                      <Draggable
                        key={item.id + item.order}
                        draggableId={"item" + item.id}
                        index={index}
                      >
                        {(provided) => (
                          <li
                            className="item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div className="product-info">
                              <Link
                                to={"/item/" + item.value + "/" + item.id}
                                className="product-title"
                              >
                                {item.label}
                                <span className="badge badge-warning float-left">
                                  {item.order}
                                </span>
                              </Link>
                              <div
                                className="text-right"
                                style={{ display: "inline", float: "right" }}
                              >
                                <Link
                                  className="btn btn-light btn-sm"
                                  to="#!"
                                  onClick={(event) =>
                                    handleRemove(event, index)
                                  }
                                >
                                  <i className="fas fa-trash"></i>
                                </Link>
                              </div>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </>
      )}
    </div>
  );
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};
export default URLFontList;
